import { graphql } from '@/generated/gql'

export const GET_CHATROOM_MESSAGES = graphql(`
    query GetMeetingChatMessages(
  $input: GetChatMessagesInput!
  $before: String
  $last: Int
  $order: [ChatMessageSortInput!]
) {
  meetingChatMessages(
    input: $input
    before: $before
    last: $last
    order: $order
  ) {
    nodes {
      id
      body
      sentAt
      isUpdated
      updatedAt
      reactions {
        reactionSymbol
        reactors {
          userId
          createdDate
          user {
            id
            displayName
            firstName
            lastName
          }
        }
      }
      sender {
        createdDate
        user {
          id
          displayName
          firstName
          lastName
          email
          imageUrl
          role
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
      hasPreviousPage
      startCursor
    }
  }
}`)

export const GET_MEETING_CHATROOMS_UNSEEN_MESSAGES =
    graphql(`query GetMeetingChatRoomsUnseenCount(
        $input: GetChatRoomsInput!
      ) {
        meetingChatRooms(input: $input) {
          nodes {
            id
            isMain
            unseenMessagesCount
          }
        }
      }
`)

export const SET_LAST_SEEN_MESSAGE =
    graphql(`mutation setLastSeenMessage($input: SetLastSeenMessageInput!){
        setLastSeenMessageV1(input: $input){
            chatMessage {
                id
            }
        }
    }`)

export const SUBSCRIBE_CHAT_MESSAGE_SENT =
    graphql(`subscription ChatMessageSent($meetingId: UUID!) {
    chatMessageSentV1(meetingId: $meetingId) {
        meetingId
        message{
            id
            body
            sentAt
            isUpdated
            updatedAt
            chatRoomId
            sender {
              createdDate
              email
              userId
            }
        }
        room {
            id
            isMain
            participants {
                email
                userId
            }
        }
    }
}`)

export const SUBSCRIBE_CHAT_MESSAGE_UPDATED =
    graphql(`subscription chatMessageUpdated($meetingId: UUID!) {
    chatMessageUpdatedV1(meetingId: $meetingId) {
        meetingId
        message{
            id
            body
            sentAt
            isUpdated
            updatedAt
            chatRoomId
            sender {
              createdDate
              email
              userId
            }
        }
        room {
            id
            isMain
            participants {
                email
                userId
            }
        }
    }
}`)

export const SUBSCRIBE_CHAT_MESSAGE_DELETED =
    graphql(`subscription chatMessageDeleted($meetingId: UUID!) {
    chatMessageDeletedV1(meetingId: $meetingId) {
        meetingId
        message{
            id
            body
            sentAt
            isUpdated
            updatedAt
            chatRoomId
            sender {
              createdDate
              email
              userId
            }
        }
        room {
            id
            isMain
            participants {
                email
                userId
            }
        }
    }
}`)
